import React from 'react';
import { Flex, Rate } from 'antd';

const Rating = ({ disabled = true, value, allowHalf = true, totalReviews, style }) => {
  return (
    <Flex vertical gap={4} style={{ ...style }}>
      <Rate disabled={disabled} defaultValue={value} allowHalf={allowHalf} />
      <span className="fs-12 fw-400" style={{ color: 'var(--gray-500)' }}>
        {!totalReviews ? 'No Reviews' : `${totalReviews} ${totalReviews > 1 ? 'Reviews' : 'Review'}`}
      </span>
    </Flex>
  );
};

export default Rating;
